export const DataQueryParamPage = 'page';
